var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-toolbar-item-change-ico",on:{"click":_vm.click}},[_vm._t("default",[_c('span',{class:_vm.currentIcon})])],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1592b2ac","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/ui-toolbar/src/ui-toolbar-item-change-ico.vue
// module id = 666
// module chunks = 0